// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<polygon
				points="16 1.61073826 9.61073826 8 16 14.3892617 14.3892617 16
					 8 9.61073826 1.61073826 16 0 14.3892617 6.38926174 8 0
					  1.61073826 1.61073826 0 8 6.38926174 14.3892617 0" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Close.js